import { BRAND_NAME } from "../contants";

export default function Footer() {
  return (
    <footer className="footer-lite mt-10">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm font-semibold text-white">{BRAND_NAME}</p>
          <p className="text-xs text-slate-300">
            CÔNG TY CỔ PHẦN ĐẦU TƯ CÔNG NGHỆ {BRAND_NAME?.toUpperCase?.() || BRAND_NAME}
          </p>
        </div>
        <p className="text-xs text-slate-400">
          © {new Date().getFullYear()} {BRAND_NAME}. Đối tác công nghệ đồng hành cùng
          doanh nghiệp.
        </p>
      </div>
    </footer>
  );
}
